export default "__VITE_ASSET__D8OBgRIY__"